import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ fontWeights }: Theme) => ({
  info: {
    marginBottom: '2rem',
    background: 'linear-gradient(286.95deg, #ffe7e9 1.2%, #e6f6ff 66.28%)',
  },
  title: {
    margin: '0 0 0.75rem',
    fontWeight: fontWeights.medium,
    fontSize: '1.25rem',
    lineHeight: 1.4,
  },
  list: {
    paddingLeft: '1.5rem',
    '& li:first-child': {
      fontWeight: fontWeights.medium,
    },
  },
  veevaNumber: {
    position: 'absolute',
    top: '0.25rem',
    left: '0.25rem',
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
